<template>
  <div></div>
</template>

<script>
import * as constants from "@/common/constants";
import config from "@/config";
import axios from "axios";
import wait from "@/wait";
import { log } from "@/logging";

export default {
  name: "home",
  data() {
    return {
      customerIdentificationNumber: "",
      notificationEmail: "",
      paymentType: "",
      paymentChannel: "",
      context: "",
      muestraVencido: "",
      metadata: {},
    };
  },
  computed: {
    pid() {
      return this.$route.params.pid;
    },
    sessionid() {
      return this.$route.params.sessionid;
    }
  },
  async created() {
    this.getOauthToken();
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': 'vpv', });
  },
  methods: {
    error: function (method, error) {
      log.error("Error trying to " + "[" + method + "] " + error);
      this.errorMS = true;
      wait.end("loading.everything");
      window.digitalData = {};
      window.dataLayer.push({ 'event': 'cargaErrorPago', });
    },
    createBillingInfo() {
      this.$store.dispatch("createBillingInfo", {
        customerIdentificationNumber: this.customerIdentificationNumber,
        paymentType: this.paymentType,
        paymentChannel: this.paymentChannel,
        context: this.context,
        homeUrl: constants.homeUrl[this.paymentChannel], // coincide para saber que home debe tomar
        email: this.notificationEmail,
        muestraVencido: this.muestraVencido,
        metadata: this.metadata,
      });
    },
    async getOauthToken() {
      try {
        const response = await axios.get(config.endpoints.oauthToken);
        if (
          response.status === 200 &&
          response.data.statusCode === 200 &&
          response.data.body !== undefined
        ) {
          log.info("getOauthToken true!");
          const tokenOauth = response.data.body;
          this.$store.getters.tokenOauth = tokenOauth;
          this.getDataUser();
        } else {
          this.error("getOauthToken", "");
        }
      } catch (e) {
        this.error("getOauthToken", e);
      }
    },
    async getDataUser() {
      //Entrar en caso /start/:pid/:sessionid
      if (this.pid && this.sessionid) {
        this.$store.getters.pid = this.pid;
        this.$store.getters.sessionId = this.sessionid;
      } else if (this.pid && !this.sessionid) {
        //Entrar en caso /start/:pid
        this.$store.getters.pid = this.pid;
      }

      const headers = {
        Authorization: "Bearer " + this.$store.getters.tokenOauth,
        sessionId: this.$store.getters.sessionId,
      };

      const data = {
        pid: this.$store.getters.pid,
      };
      try {
        wait.start("loading.everything");
        const response = await axios.post(config.endpoints.getDataUser, data, {
          headers,
        });

        if (response.status === 200) {
          console.info("getDataUser true!");
          if (this.$store.getters.sessionId !== undefined) {
            this.customerIdentificationNumber = response.data.data.customerIdentificationNumber;
            this.notificationEmail = response.data.data.email;
            this.paymentType = response.data.data.paymentType;
            this.paymentChannel = response.data.data.paymentChannel;
            this.context = "cloud";
            this.muestraVencido = true;
            this.metadata = response.data.data.metadata;
            this.metadata.totalOverdue = this.metadata.totalOvedue;

            try {
              /** Se limpia state cuando se entra a pagar por primera vez */
              this.$store.dispatch("resetBillingState");
              this.$store.dispatch("resetPaymentState");
              this.$store.dispatch("resetInteractionState");
              /** Finaliza limpieza */
              this.createBillingInfo();

              await this.$store.dispatch("updateBillingInfo", {
                sessionId: this.$store.getters.sessionId,
              });
              let rutConDeuda = this.$store.getters.billingInfo.rutSinDeuda
                ? false
                : true;
             
              let cuentaConDeuda = this.$store.getters.billingInfo
                .cuentaConDeuda
                ? true
                : false;

              if (rutConDeuda && cuentaConDeuda) {
                this.$router.push({
                  path: "/billing",
                });
                console.debug("Router pushed!");
              } else {
                window.location.replace(config.url.base + "/errorservice");
              }
            } catch (e) {
              window.location.replace(config.url.base + "/errorservice");
              console.error(e);
            }
          } else {
            if (this.pid) {
              this.$router.push({
                path: "/initial/" + this.pid,
              });
            } else {
              this.$router.push({
                path: "/initial/",
              });
            }
          }
          wait.end("loading.everything");
        } else {
          window.location.replace(config.url.base + "/errorservice");
          console.error("getDataUser false!");
        }
      } catch (e) {
        window.location.replace(config.url.base + "/errorservice");
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/style/main.scss";
</style>
